import React from 'react'
import {Icon} from 'src/common/Icon'

const LANDSCAPE_ROWS = [
  {
    name: 'Cloud Infrastructure',
    examples: 'Google Cloud, AWS, Hetzner...',
    width: 100,
    share: '20.4%',
    yoy: '+23%',
    yoyDir: 'up' as const,
    trend: 'Growing',
  },
  {
    name: 'Dev Tools',
    examples: 'GitHub, Atlassian, JetBrains...',
    width: 95,
    share: '19.3%',
    yoy: '−20%',
    yoyDir: 'down' as const,
    trend: 'Consolidating',
    rowClass: 'dev',
  },
  {
    name: 'AI Tools',
    examples: 'OpenAI, Anthropic, ElevenLabs...',
    width: 75,
    share: '15.4%',
    yoy: '+309%',
    yoyDir: 'up' as const,
    trend: 'Exploding',
    rowClass: 'ai',
    trendBold: true,
  },
  {
    name: 'Comms & Collab',
    examples: 'Microsoft, Slack, Notion...',
    width: 66,
    share: '13.5%',
    yoy: '+23%',
    yoyDir: 'up' as const,
    trend: 'Growing',
  },
  {
    name: 'CRM & Sales',
    examples: 'LinkedIn, HubSpot, Pipedrive...',
    width: 31,
    share: '6.4%',
    yoy: '+12%',
    yoyDir: 'up' as const,
    trend: 'Stable',
  },
  {
    name: 'Design',
    examples: 'Adobe, Figma, Canva...',
    width: 21,
    share: '4.2%',
    yoy: '+36%',
    yoyDir: 'up' as const,
    trend: 'Growing',
  },
  {
    name: 'Marketing',
    examples: 'Typeform, Sendinblue, Mailchimp...',
    width: 20,
    share: '4.0%',
    yoy: '+48%',
    yoyDir: 'up' as const,
    trend: 'Growing fast',
  },
  {
    name: 'E-commerce',
    examples: 'Shopify...',
    width: 19,
    share: '3.9%',
    yoy: '+72%',
    yoyDir: 'up' as const,
    trend: 'Growing fast',
  },
  {
    name: 'HR & People',
    examples: 'Personio, LinkedIn Recruiter, Join.com...',
    width: 13,
    share: '2.6%',
    yoy: '+54%',
    yoyDir: 'up' as const,
    trend: 'Growing',
  },
  {
    name: 'AI Dev Tools',
    examples: 'Cursor, Lovable, Replit...',
    width: 11,
    share: '2.3%',
    yoy: '+1,009%',
    yoyDir: 'up' as const,
    trend: 'Exploding',
    rowClass: 'ai',
    trendBold: true,
  },
]

const CategoryLandscape: React.FC = () => (
  <section id="landscape" className="section light">
    <div className="wrap">
      <div className="subsection" style={{marginTop: 0}}>
        <div className="eyebrow eyebrow-dot" style={{fontSize: 11, marginBottom: 12}}>
          The category landscape
        </div>
        <h3>€46.6M across 19 SaaS categories Jan–May 2026.</h3>
        <p className="sub-intro">
          Top 10 categories by share of total European SaaS spend. YoY = like-for-like comparison: Jan–May 2025 vs
          Jan–May 2026.
        </p>
      </div>
      <div className="cat-bars">
        <div className="cat-bars-header">
          <div>Top categories by spend share</div>
          <Icon name="moss-logo-v2" className="chart-logo" />
        </div>
        {LANDSCAPE_ROWS.map((row) => (
          <div key={row.name} className={`row${row.rowClass ? ` ${row.rowClass}` : ''}`}>
            <div className="name">
              {row.name}
              <span className="examples">{row.examples}</span>
            </div>
            <div className="bar">
              <span style={{width: `${row.width}%`}} />
            </div>
            <div className="share">{row.share}</div>
            <div className={`yoy ${row.yoyDir}`}>{row.yoy}</div>
            <div className="trend">{row.trendBold ? <strong>{row.trend}</strong> : row.trend}</div>
          </div>
        ))}
      </div>
      <div className="cat-callouts">
        <div className="ccal neon">
          <div className="hd">AI Tools breakout</div>
          <div className="big mono-num">5.1% → 15.4%</div>
          <div className="body">
            AI Tools jumped from 5.1% to <strong>15.4% of all SaaS spend</strong>, now the 3rd-largest category,
            overtaking Comms &amp; Collab.
          </div>
        </div>
        <div className="ccal">
          <div className="hd">CRM teaser</div>
          <div className="big">HubSpot vs Clay</div>
          <div className="body">
            HubSpot and Clay are neck-and-neck on switch-ins (34 vs 33). Salesforce? <strong>Just 6 switch-ins</strong>{' '}
            across 29 months. <em style={{color: 'var(--moss-neon)'}}>Pick the CRM tab.</em>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default CategoryLandscape
